export enum OrderTypes {
	EVENT = "EVENT",
	CALENDAR = "CALENDAR",
}
